export enum MarblesGlossary {
  Completion = '|',
  Error = '#',
  TimeFrame = '-',
  Subscription = '^',
  Unsubscription = '!',
  GroupStart = '(',
  GroupEnd = ')',
}
